<template>
  <div class="app-main-content">
    <div class="details-view">
      <div class="section" style="height: 100%;padding: 0 5px;display: flex;flex-direction: row;">
        <cargo-ag-grid
          :grid-options="gridOptions"
          :row-data="rowData"
          :show-side-bar="false"
          :class="isPreview || isEdit ? 'not-click' : ''"
          style="flex: 0 0 auto;width: 200px;margin: 5px 0;"
        />
        <div style="flex: 0 0 auto;width: 2px;margin: 0 5px;background: #DCDFE6;" />
        <div class="main-content" style="flex-grow: 1;height: auto;margin: 5px 0;">
          <div class="operations">
            <div class="triggers">
              <div v-if="!!validateRow" style="padding-left: 5px;margin-bottom: 5px;">
                <template v-if="isPreview">
                  <el-button key="back" type="primary" @click="isPreview=false;previewConfig=null">{{ $t('CargoMsg.Cargo_Back') }}</el-button>
                </template>
                <template v-if="!isPreview">
                  <template v-if="readonly">
                    <el-button key="edit" type="primary" @click="onEdit">{{ $t('Message.Edit') }}</el-button>
                    <el-button key="readPreview" type="primary" @click="onPreview">{{ $t('CargoMsg.Cargo_Preview') }}</el-button>
                  </template>
                  <template v-else>
                    <el-button key="save" type="success" @click="onSave">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
                    <el-button key="cancel" type="success" @click="onCancel">{{ $t('Message.Cancel') }}</el-button>
                    <el-button key="editPreview" type="primary" @click="onPreview">{{ $t('CargoMsg.Cargo_Preview') }}</el-button>
                    <el-button key="reset" type="warning" @click="onReset">{{ $t('Message.Reset') }}</el-button>
                  </template>
                  <span key="opOffice" style="margin: 0px 8px;">{{ $t('CargoMsg.Cargo_BranchCompany') }}</span>
                  <el-select v-model="branchId" :disabled="isEdit" filterable @change="loadData()">
                    <el-option v-for="(item,index) in officeList" :key="index" :label="getOfficeLabel(item)" :value="item.officeId" />
                  </el-select>
                </template>
              </div>
            </div>
          </div>
          <template v-if="validateRow">
            <sea-booking-basic
              v-if="validateRow.pageType === SEA_BOOKING_BASIC"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="[]"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <sea-booking-vessel
              v-if="validateRow.pageType === SEA_BOOKING_VESSEL"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <sea-booking-special-goods
              v-if="validateRow.pageType === SEA_BOOKING_SPECIAL_GOODS"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <customs-info
              v-if="validateRow.pageType === SEA_BOOKING_CUSTOMS"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <sea-booking-trucking
              v-if="validateRow.pageType === SEA_BOOKING_TRUCKING"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <sea-booking-discharging-trucking
              v-if="validateRow.pageType === SEA_BOOKING_DISCHARGING_TRUCKING"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <sea-booking-container
              v-if="validateRow.pageType === SEA_BOOKING_CONTAINER_INFO"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <ic-booking-basic
              v-if="validateRow.pageType === INTEGRATED_IC_BOOKING"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <cl-booking-basic
              v-if="validateRow.pageType === INTEGRATED_CL_BOOKING"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <tt-booking-basic
              v-if="validateRow.pageType === INTEGRATED_TT_BOOKING"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <sea-booking-internal-bill
              v-if="validateRow.pageType === SEA_BOOKING_DOMESTIC_BILLING"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <sea-booking-oversea-bill
              v-if="validateRow.pageType === SEA_BOOKING_OVERSEA_BILL"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            />
            <grid-tab
              v-if="gridTabPageTypes.includes(validateRow.pageType)"
              :branch-id="branchId"
              :is-edit="isEdit"
              :blocks="blocks"
              :added-elements="addedElementsForEdit"
              :is-preview="isPreview"
              :preview-config="previewConfig"
            >
              <se-tab-lcl-container slot="preview" :context="seBookingWorkspaceContext" action="look" :preview-config="previewConfig" :enable-ui-custom="true" />
            </grid-tab>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { BookingWorkspaceContext as SeBookingWorkspaceContext } from '@/views/cargo/v0/SeaExport/components/booking/bookingWorkspaceContext'
import seaBookingBasic from '@/views/cargo/v0/SystemMaintenance/components/pageUserUICustom/seaBookingBasic'
import seaBookingVessel from '@/views/cargo/v0/SystemMaintenance/components/pageUserUICustom/seaBookingVessel'
import seaBookingSpecialGoods from '@/views/cargo/v0/SystemMaintenance/components/pageUserUICustom/seaBookingSpecialGoods'
import customsInfo from '@/views/cargo/v0/SystemMaintenance/components/pageUserUICustom/customsInfo'
import seaBookingTrucking from '@/views/cargo/v0/SystemMaintenance/components/pageUserUICustom/seaBookingTrucking'
import seaBookingDischargingTrucking from '@/views/cargo/v0/SystemMaintenance/components/pageUserUICustom/seaBookingDischargingTrucking'
import seaBookingContainer from '@/views/cargo/v0/SystemMaintenance/components/pageUserUICustom/seaBookingContainer'
import { getUserElementBlockList, saveUserBlocks } from '@/api/sysManage/uiCustom'
import lodash from 'lodash'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import ClBookingBasic from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/clBookingBasic.vue'
import TtBookingBasic from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/ttBookingBasic.vue'
import IcBookingBasic from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/icBookingBasic.vue'
import seaBookingInternalBill from '@/views/cargo/v0/SystemMaintenance/components/pageUserUICustom/seaBookingInternalBill'
import seaBookingOverseaBill from '@/views/cargo/v0/SystemMaintenance/components/pageUserUICustom/seaBookingOverseaBill'
import gridTab from '@/views/cargo/v0/SystemMaintenance/components/pageUserUICustom/gridTab'
import seTabLclContainer from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabLclContainer'

export default {
  name: 'PageUserUICustom',
  components: { IcBookingBasic, TtBookingBasic, ClBookingBasic, seaBookingBasic, seaBookingVessel, seaBookingSpecialGoods, customsInfo, seaBookingTrucking, seaBookingDischargingTrucking, seaBookingContainer, seaBookingInternalBill, seaBookingOverseaBill, gridTab, seTabLclContainer },
  data() {
    return {
      SEA_BOOKING_BASIC: UICustomConstants.SEA_BOOKING_BASIC,
      SEA_BOOKING_VESSEL: UICustomConstants.SEA_BOOKING_VESSEL,
      SEA_BOOKING_SPECIAL_GOODS: UICustomConstants.SEA_BOOKING_SPECIAL_GOODS,
      SEA_BOOKING_CUSTOMS: UICustomConstants.SEA_BOOKING_CUSTOMS,
      SEA_BOOKING_TRUCKING: UICustomConstants.SEA_BOOKING_TRUCKING,
      SEA_BOOKING_DISCHARGING_TRUCKING: UICustomConstants.SEA_BOOKING_DISCHARGING_TRUCKING,
      INTEGRATED_IC_BOOKING: UICustomConstants.INTEGRATED_IC_BOOKING,
      INTEGRATED_CL_BOOKING: UICustomConstants.INTEGRATED_CL_BOOKING,
      INTEGRATED_TT_BOOKING: UICustomConstants.INTEGRATED_TT_BOOKING,
      SEA_BOOKING_CONTAINER_INFO: UICustomConstants.SEA_BOOKING_CONTAINER_INFO,
      SEA_BOOKING_DOMESTIC_BILLING: UICustomConstants.SEA_BOOKING_DOMESTIC_BILLING,
      SEA_BOOKING_OVERSEA_BILL: UICustomConstants.SEA_BOOKING_OVERSEA_BILL,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressContextMenu: false,
        treeData: true,
        groupDefaultExpanded: 3,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('SystemMaintenance.Name'),
          field: 'name',
          width: 187,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            innerRenderer: params => {
              return params.value
            }
          },
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        columnDefs: [],
        context: {
          componentParent: this
        },
        onRowClicked: event => {
          if (event.data.dataType === 2) {
            this.validateRow = event.data
          } else {
            this.validateRow = null
          }
          this.loadData()
        }
      },
      rowData: [
        { name: this.$t('CargoMsg.Cargo_OceanExport'), path: 'SE', dataType: 1 },
        { name: this.$t('CargoMsg.Cargo_SeaBooking'), path: 'SE,bookingNew', dataType: 1 },
        { name: this.$t('SystemMaintenance.BasicTab'), path: 'SE,bookingNew,basic', dataType: 2, pageType: UICustomConstants.SEA_BOOKING_BASIC },
        { name: this.$t('Message.BookingLabel'), path: 'SE,bookingNew,vessel', dataType: 2, pageType: UICustomConstants.SEA_BOOKING_VESSEL },
        { name: this.$t('SystemMaintenance.ShippingInformationNonMainInvoice'), path: 'SE,bookingNew,container', dataType: 2, pageType: UICustomConstants.SEA_BOOKING_CONTAINER_INFO },
        { name: this.$t('SystemMaintenance.ShippingInformationMasterBill'), path: 'SE,bookingNew,containerMaster', dataType: 2, pageType: UICustomConstants.SEA_BOOKING_CONTAINER_INFO_MASTER },
        { name: this.$t('SeaExport.Trucking'), path: 'SE,bookingNew,trucking', dataType: 2, pageType: UICustomConstants.SEA_BOOKING_TRUCKING },
        { name: this.$t('SeaExport.DispatchVehiclesAtDestination'), path: 'SE,bookingNew,dischargingTrucking', dataType: 2, pageType: UICustomConstants.SEA_BOOKING_DISCHARGING_TRUCKING },
        { name: this.$t('CargoMsg.Cargo_CustomsDeclaration'), path: 'SE,bookingNew,customs', dataType: 2, pageType: UICustomConstants.SEA_BOOKING_CUSTOMS },
        { name: this.$t('SeaExport.InternalBillInfo'), path: 'SE,bookingNew,internalBillInfo', dataType: 2, pageType: UICustomConstants.SEA_BOOKING_DOMESTIC_BILLING },
        { name: this.$t('SeaExport.OverseaBillInfo'), path: 'SE,bookingNew,overseaBillInfo', dataType: 2, pageType: UICustomConstants.SEA_BOOKING_OVERSEA_BILL },
        { name: this.$t('SpecialGoods.label'), path: 'SE,bookingNew,specialGoods', dataType: 2, pageType: UICustomConstants.SEA_BOOKING_SPECIAL_GOODS },
        { name: this.$t('CargoMsg.Cargo_IntegratedJob'), path: 'IE', dataType: 1 },
        { name: this.$t('CargoMsg.Cargo_IC'), path: 'IE,icBooking', dataType: 1 },
        { name: this.$t('CargoMsg.Cargo_IC_Basic'), path: 'IE,icBooking,basic', dataType: 2, pageType: UICustomConstants.INTEGRATED_IC_BOOKING },
        { name: this.$t('CargoMsg.Cargo_WholeVehicleAndLessThanCarload'), path: 'IE,clBooking', dataType: 1 },
        { name: this.$t('SystemMaintenance.BasicTab'), path: 'IE,clBooking,basic', dataType: 2, pageType: UICustomConstants.INTEGRATED_CL_BOOKING },
        { name: this.$t('CargoMsg.Cargo_TruckTrailer'), path: 'IE,ttBooking', dataType: 1 },
        { name: this.$t('SystemMaintenance.BasicTab'), path: 'IE,ttBooking,basic', dataType: 2, pageType: UICustomConstants.INTEGRATED_TT_BOOKING }
      ],
      validateRow: null,
      officeConfigLabel: '',
      officeList: [],
      branchId: this.$store.getters.currentOfficeId,
      isEdit: false,
      branchBlocks: [],
      userBlocks: [],
      blocks: [],
      isPreview: false,
      previewConfig: null,
      addedElementsForEdit: [],
      gridTabPageTypes: [
        UICustomConstants.SEA_BOOKING_CONTAINER_INFO_MASTER
      ],
      seBookingWorkspaceContext: new SeBookingWorkspaceContext()
    }
  },
  computed: {
    readonly() {
      return !this.isEdit
    }
  },
  created() {
    const configs = this.$store.state.settings.partnerLabelSettings
    const officeConfig = configs.find(config => config.autoKey === 'auto_office')
    this.officeConfigLabel = Object.keys(officeConfig).find(key => typeof officeConfig[key] === 'boolean' && officeConfig[key])
    this.officeList = this.$store.state.user.userInfo.currentUserOfficeList
    this.seBookingWorkspaceContext.prepareData()
  },
  methods: {
    getOfficeLabel(item) {
      switch (this.officeConfigLabel) {
        case 'chineseName':
          return item.chineseName
        case 'englishName':
          return item.englishName
        default:
          return item.code
      }
    },
    loadData() {
      if (!this.validateRow || !this.validateRow.pageType || !this.branchId) {
        this.branchBlocks = []
        this.userBlocks = []
        this.blocks = []
        return
      }
      const loading = getLoading4Cxt(this)
      getUserElementBlockList({ pageType: this.validateRow.pageType, branchId: this.branchId }).then(res => {
        const data = res.data
        this.branchBlocks = data.branchBlocks
        this.userBlocks = data.userBlocks
        if (this.userBlocks.length === 0) {
          this.doResetBlocksFromBranch(this.userBlocks)
        }
        this.blocks = this.userBlocks
      }).finally(() => {
        loading.close()
      })
    },
    onEdit() {
      this.blocks = lodash.cloneDeep(this.userBlocks)
      this.isEdit = true
    },
    onPreview() {
      /* 构建用户block和element的映射关系 */
      const userBlockDict = {}
      let maxUserBlockSerialNumber = 0
      const userElementDict = {}
      const userAllElementNames = []
      for (const block of this.blocks) {
        const elementBlock = {
          elementNames: [],
          position: block.pagePartPosition,
          serialNumber: block.serialNumber
        }
        if (block.serialNumber > maxUserBlockSerialNumber) {
          maxUserBlockSerialNumber = block.serialNumber
        }
        for (const element of block.uiCustomElementList) {
          elementBlock.elementNames.push(element.pagePartElement.elementName)
          userAllElementNames.push(element.pagePartElement.elementName)
          const obj = {
            visible: element.isDisplay,
            masterVisible: element.masterIsDisplay,
            slaveVisible: element.slaveIdDisplay
          }
          userElementDict[element.pagePartElement.elementName] = obj
        }
        userBlockDict[block.pagePart.pagePartName] = elementBlock
      }

      /* 构建分公司block和element的映射关系（附加上用户block、element信息） */
      const elementBlocks = []
      const elementDict = {}
      const fieldDict = {}
      for (const block of this.branchBlocks) {
        const elementBlock = {
          title: block.customLabel || block.sysLabel,
          name: block.pagePart.pagePartName,
          elementNames: [],
          position: block.pagePartPosition,
          hide: block.hide
        }
        const userBlock = userBlockDict[block.pagePart.pagePartName]
        if (userBlock) {
          elementBlock.elementNames = userBlock.elementNames
          elementBlock.position = userBlock.position
          elementBlock.serialNumber = userBlock.serialNumber
        } else {
          elementBlock.serialNumber = ++maxUserBlockSerialNumber
        }
        for (const element of block.uiCustomElementList) {
          if (!userAllElementNames.includes(element.pagePartElement.elementName)) {
            elementBlock.elementNames.push(element.pagePartElement.elementName)
          }
          const fieldNames = []
          if (element.uiCustomFieldList) {
            for (const field of element.uiCustomFieldList) {
              fieldDict[field.fieldDict.fieldName] = {
                visible: field.isDisplay,
                masterVisible: field.masterIsDisplay,
                slaveVisible: field.slaveIdDisplay,
                isRequire: field.isRequire,
                label: field.customLabel || field.sysLabel
              }
              fieldNames.push(field.fieldDict.fieldName)
            }
          }
          const obj = {
            visible: element.isDisplay,
            masterVisible: element.masterIsDisplay,
            slaveVisible: element.slaveIdDisplay,
            isRequire: element.isRequire,
            label: element.customLabel || element.sysLabel,
            fieldNames
          }
          if (element.isDisplay) {
            obj.viewable = true
            obj.writable = true
          } else {
            obj.viewable = false
            obj.writable = false
          }
          const userElement = userElementDict[element.pagePartElement.elementName]
          if (userElement) {
            obj.visible = userElement.visible
            obj.masterVisible = userElement.masterVisible
            obj.slaveVisible = userElement.slaveVisible
            obj.userCustomContent = userElement.userCustomContent ? JSON.parse(userElement.userCustomContent) : ''
          } else {
            obj.visible = false
            obj.masterVisible = false
            obj.slaveVisible = false
            obj.userCustomContent = ''
          }
          elementDict[element.pagePartElement.elementName] = obj
        }
        elementBlocks.push(elementBlock)
      }
      elementBlocks.sort((a, b) => a.serialNumber - b.serialNumber)
      if (this.gridTabPageTypes.includes(this.validateRow.pageType)) {
        this.previewConfig = {}
        for (const elementBlock of elementBlocks) {
          const partElementDict = {}
          for (const elementName of elementBlock.elementNames) {
            partElementDict[elementName] = elementDict[elementName]
          }
          this.previewConfig[elementBlock.name] = partElementDict
        }
      } else {
        this.previewConfig = {
          elementBlocks,
          elementDict,
          fieldDict,
          pageType: this.validateRow.pageType
        }
      }
      this.isPreview = true
    },
    async onSave() {
      const loading = getLoading4Cxt(this)
      try {
        // 和旧版数据对比，加上是否修改标识
        this.compareAndSetDirty(this.blocks, this.userBlocks)
        const userElementBlocks = lodash.cloneDeep(this.blocks)
        // 清空空对象，否则后端用对象接收空字符串会报错
        this.clearBlockEmptyObj(userElementBlocks)
        await saveUserBlocks(userElementBlocks)
        loading.close()
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        this.isEdit = false
        this.loadData()
        this.updateGlobalUICustom(this.validateRow.pageType, this.branchId)
      } catch {
        loading.close()
      }
    },
    // 清空空对象
    clearBlockEmptyObj(blocks) {
      for (const block of blocks) {
        const pagePart = block.pagePart
        if (!pagePart.languageList) {
          delete pagePart.languageList
        }
        for (const pagePartElement of pagePart.pagePartElementList) {
          if (!pagePartElement.languageList) {
            delete pagePartElement.languageList
          }
          if (!pagePartElement.fieldDictList) {
            delete pagePartElement.fieldDictList
          }
        }
        for (const element of block.uiCustomElementList) {
          const pagePartElement = element.pagePartElement
          if (!pagePartElement.languageList) {
            delete pagePartElement.languageList
          }
          if (!pagePartElement.fieldDictList) {
            delete pagePartElement.fieldDictList
          }
        }
        for (const element of block.invalidElementList) {
          const pagePartElement = element.pagePartElement
          if (!pagePartElement.languageList) {
            delete pagePartElement.languageList
          }
          if (!pagePartElement.fieldDictList) {
            delete pagePartElement.fieldDictList
          }
        }
      }
    },
    compareAndSetDirty(newData, oldData) {
      if (newData instanceof Array) {
        for (const newItem of newData) {
          const oldItem = newItem.uuid && oldData ? oldData.find(p => p.uuid === newItem.uuid) || {} : {}
          this.compareAndSetDirty(newItem, oldItem)
        }
      } else if (newData instanceof Object) {
        if (!newData.uuid) {
          newData.dirty = true
        }
        for (const key in newData) {
          if (newData[key] instanceof Array) {
            this.compareAndSetDirty(newData[key], oldData[key] || [])
            continue
          }
          if (newData[key] instanceof Object) {
            this.compareAndSetDirty(newData[key], oldData[key] || {})
            continue
          }
          if (newData[key] !== oldData[key]) {
            newData.dirty = true
          }
        }
      }
    },
    updateGlobalUICustom(pageType, branchId) {
      if (!pageType) {
        return
      }
      if (this.$store.state.uiCustom.enable) {
        this.$store.dispatch('uiCustom/updateUICustomPageInfo', { pageType, branchIds: branchId === 1 ? Array.from(this.officeList, p => p.officeId) : [branchId] })
      }
    },
    onCancel() {
      this.$confirm(this.$t('CargoMsg.Cargo_CCOCM'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('Message.Cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.blocks = this.userBlocks
        this.isEdit = false
      }).catch(() => { })
    },
    onReset() {
      this.$confirm(this.$t('SystemMaintenance.ResetCustomSetConfirm'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('Message.Cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.doResetBlocksFromBranch(this.blocks)
      }).catch(() => { })
    },
    // 使用分公司block重置blocks
    doResetBlocksFromBranch(blocks) {
      const oldBlockMap = new Map()
      const oldElementMap = new Map()
      for (const block of blocks) {
        oldBlockMap.set(block.pagePart.pagePartName, block)
        for (const element of block.uiCustomElementList) {
          oldElementMap.set(element.pagePartElement.uuid, element)
        }
      }
      const newBlocks = []
      for (const branchBlock of this.branchBlocks) {
        const newBlock = oldBlockMap.get(branchBlock.pagePart.pagePartName) || { pagePart: branchBlock.pagePart }
        newBlock.pagePartUuid = branchBlock.pagePartUuid
        newBlock.pagePartPosition = branchBlock.pagePartPosition
        newBlock.branchId = branchBlock.branchId
        newBlock.userId = this.$store.getters.userId
        newBlock.serialNumber = branchBlock.serialNumber
        newBlock.sysLabel = branchBlock.sysLabel
        newBlock.customLabel = branchBlock.customLabel
        newBlock.dirty = true
        newBlock.pagePart = branchBlock.pagePart
        newBlock.uiCustomElementList = []
        newBlock.invalidElementList = newBlock.invalidElementList || []
        newBlocks.push(newBlock)
        let serialNumber = 1
        for (const branchElement of branchBlock.uiCustomElementList) {
          const newElement = oldElementMap.get(branchElement.pagePartElement.uuid) || { pagePartElement: branchElement.pagePartElement }
          newElement.uiCustomElementBlockUserUuid = newBlock.uuid
          newElement.pagePartElementUuid = branchElement.pagePartElementUuid
          newElement.branchId = branchElement.branchId
          newElement.userId = this.$store.getters.userId
          newElement.branchIsDisplay = branchElement.isDisplay
          newElement.branchMasterIsDisplay = branchElement.masterIsDisplay
          newElement.branchSlaveIdDisplay = branchElement.slaveIdDisplay
          newElement.isDisplay = branchElement.isDisplay
          newElement.masterIsDisplay = branchElement.masterIsDisplay
          newElement.slaveIdDisplay = branchElement.slaveIdDisplay
          newElement.isRequire = branchElement.isRequire
          newElement.serialNumber = serialNumber++
          newElement.userCustomContent = ''
          newElement.sysLabel = branchElement.sysLabel
          newElement.customLabel = branchElement.customLabel
          newElement.dirty = true
          newElement.pagePartElement = branchElement.pagePartElement
          newElement.invalid = !branchElement.isDisplay
          if (newElement.invalid) {
            if (newElement.uuid && newBlock.invalidElementList.findIndex(p => p.uuid === newElement.uuid) === -1) {
              newBlock.invalidElementList.push(newElement)
            }
          } else {
            newBlock.uiCustomElementList.push(newElement)
          }
        }
      }
      blocks.splice(0, blocks.length, ...newBlocks)
    }
  }
}
</script>

<style lang="scss" scoped>
  .not-click {
    pointer-events: none;
  }
</style>
